import React from "react";
import Card from "components/card";
import MetricCard from "components/card/MetricCard";
import {
    Activity,
    Calendar,
    ChartColumn,
    Clock,
    Target,
    TrendingUp,
} from "lucide-react";

const ProgramProgressCard = ({ employee }) => {
    if (!employee) return null;

    const { initials, name, role, details } = employee;
    const { program, status, metrics, timeline, time_investment } = details;

    return (
        <Card className="flex flex-col gap-6 rounded-2xl border-2 border-purple-500 bg-white shadow-md">
            <div className="bg-purple-50/30 border-b border-slate-200 rounded-t-xl items-start gap-1.5 px-6 pt-6 pb-6">
                <div className="flex items-start justify-between">
                    <div className="flex items-center gap-3">
                        <span className="relative flex shrink-0 overflow-hidden rounded-full w-16 h-16 border-2 border-white shadow-md">
                            <span className="flex size-full items-center justify-center rounded-full bg-purple-500 text-white font-semibold text-[18px]">
                                {initials}
                            </span>
                        </span>
                        <div>
                            <h4 className="text-[24px]">
                                {name}
                            </h4>
                            <p className="text-[13px] text-slate-500">
                                {role}
                            </p>
                            <span className="inline-flex items-center justify-center rounded-xl px-2 py-0.5 text-xs font-semibold w-fit shrink-0 mt-1 bg-purple-100 text-purple-700 hover:bg-purple-200 border border-purple-200">
                                {program}
                            </span>
                        </div>
                    </div>
                    <span className={`status-indicator ${status.toLowerCase().replace(/\s+/g, "-")} text-[11px]`}>
                        {status}
                    </span>
                </div>
            </div>
            <div className="pb-6 p-6">
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <MetricCard
                        label="Pre-Score"
                        Icon={ChartColumn}
                        value={metrics.pre_score}
                        color="blue"
                    />
                    <MetricCard
                        label="Current"
                        Icon={Activity}
                        value={metrics.current}
                        color="purple"
                    />
                    <MetricCard
                        label="Target"
                        Icon={Target}
                        value={metrics.target}
                        color="green"
                    />
                    <MetricCard
                        label="Growth"
                        Icon={TrendingUp}
                        value={`+${metrics.growth}%`}
                        color="orange"
                    />
                </div>
                <div className="bg-gray-200 h-px w-full my-6"></div>
                <div className="grid grid-cols-2 gap-6">
                    <div>
                        <div className="flex items-center gap-2 mb-2">
                            <Calendar className="w-4 h-4 text-purple-600"/>
                            <p className="text-[12px] font-medium">
                                Program Timeline
                            </p>
                        </div>
                        <p className="text-[11px] text-slate-500">
                            Started: {timeline.start_date}
                        </p>
                        <p className="text-[11px] text-slate-500">
                            Target End: {timeline.target_end_date}
                        </p>
                    </div>
                    <div>
                        <div className="flex items-center gap-2 mb-2">
                            <Clock className="w-4 h-4 text-purple-600"/>
                            <p className="text-[12px] font-medium">
                                Time Investment
                            </p>
                        </div>
                        <p className="text-[11px] text-slate-500">
                            Completed: {time_investment.completed_hours}/{time_investment.total_hours}h
                        </p>
                        <div className="w-full h-1.5 mt-1 rounded-full bg-emerald-100 overflow-hidden">
                            <div
                                className="h-full bg-emerald-600"
                                style={{ width: `${time_investment.progress_percent}%` }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default ProgramProgressCard;